import { ISilderName, ItemRoutesProps } from "./PageRoute";
import DashboardTemplate from "../../Template/DashboardTemplate";
import { IPermissionActionType } from "../../Pages/Users/Roles/UserPermissionCommonData";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";
import { SettingsSections } from "../../Services/SettingService";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import { Route } from "react-router-dom";
import ResourceNotFound from "../ResourceNotFound";
import AddSalesInvoiceAndPurchaseBill from "../../Pages/SalesAndPurchase/InvoiceAndPurchaseBill/Add/AddSalesInvoiceAndPurchaseBill";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import PurchaseNestedRoute from "../../Pages/SalesAndPurchase/NestedRoute/PurchaseNestedRoute";
import AddSalesCreditNotesNew from "../../Pages/SalesAndPurchase/CreditAndDebitNote/Add/AddCreditAndDebitNotesNew";
import AddPaymentInNew from "../../Pages/SalesAndPurchase/ReceiptAndPaymentOut/Add/AddPaymentIn";
import AddOrderEstimateProformaInvoice from "../../Pages/SalesAndPurchase/Order/Add/AddOrderEstimateProformaInvoice";
import GroupDetails from "../../Pages/Master/Group/AllDetailsGroupWise/GroupDetails";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import LedgerDetails from "../../Pages/Master/Ledger/LedgerDetails";

const PurchaseRoute = ({
  currentClient,
  clientSpecificRole,
}: ItemRoutesProps) => {
  return (
    <>
      {/* ----------- Purchase Route ----------- */}
      <Route
        key="dashboard"
        path={`/${currentClient?.id}/purchase/*`}
        element={
          findUserPremission(
            [
              "Voucher.Purchase.7.View",
              "Voucher.Purchase.8.View",
              "Voucher.Purchase.10.View",
              "Voucher.Purchase.9.View",
              "Master.Ledger.Suppliers.View",
            ],
            clientSpecificRole(),
            currentClient?.id,
            [
              SettingsSections.PurInvoice,
              SettingsSections.DrNote,
              SettingsSections.Payment,
              SettingsSections.POrder,
            ],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesInvoiceTemplate
              element={<PurchaseNestedRoute />}
              silderName={ISilderName.Purchase}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
              ]}
              menuprops={[
                {
                  showData: "Purchase Bill",
                  addButton: "addInvoice",
                },
                {
                  showData: "Debit Note",
                  addButton: "addDebitNote",
                },
                {
                  showData: "Payment Out",
                  addButton: "addPaymentOut",
                },
                {
                  showData: "Purchase Order",
                  addButton: "addOrder",
                },
                {
                  showData: "Suppliers",
                  addButton: "suppliers",
                },
                // {
                //   showData: "Items",
                //   addButton: "purchaseItem",
                // },
                // {
                //   showData: "Suppliers",
                // },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/addPurchaseBill`}
        element={
          findUserPremission(
            ["Voucher.Purchase.7.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.PurInvoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Invoice",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/editPurchaseBill/:updateId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.7.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.PurInvoice],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "purchaseBill",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/cloneBill/:cloneId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.7.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.PurInvoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "PurchaseBill",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Clone",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/editBillDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.7.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.PurInvoice],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "purchaseBill",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* Add Purchase order to Purchase invoice */}
      <Route
        path={`${currentClient?.id}/purchase/addPurchaseBill/order/:purchaseOrderId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.7.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.PurInvoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "PurchaseBill",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Order",
                  path: `/billing/clients/${currentClient?.id}/purchase/order`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------- Debit Note ----------- */}
      <Route
        path={`${currentClient?.id}/purchase/addDebitNote`}
        element={
          findUserPremission(
            ["Voucher.Purchase.8.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.DrNote],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesCreditNotesNew />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Debit Note",
                  path: `/billing/clients/${currentClient?.id}/purchase/debitNote`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/editDebitNote/:creditNoteId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.8.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.DrNote],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesCreditNotesNew />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Debit Note",
                  path: `/billing/clients/${currentClient?.id}/purchase/debitNote`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/editDebitNoteDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.8.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.DrNote],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesCreditNotesNew />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "DebitNote",
                  path: `/billing/clients/${currentClient?.id}/purchase/debitNote`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------- Payment Out ----------- */}
      <Route
        path={`${currentClient?.id}/purchase/addPaymentOut`}
        element={
          findUserPremission(
            ["Voucher.Purchase.10.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.POrder],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddPaymentInNew />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Payments",
                  path: `/billing/clients/${currentClient?.id}/purchase/paymentOut`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/editPaymentOut/:paymentId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.10.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Payment],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddPaymentInNew />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Payments",
                  path: `/billing/clients/${currentClient?.id}/purchase/paymentOut`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/editPaymentOutDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.10.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.POrder],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddPaymentInNew />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "PaymentOut",
                  path: `/billing/clients/${currentClient?.id}/purchase/paymentOut`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------- Purchase Order  ----------- */}
      <Route
        path={`${currentClient?.id}/purchase/addOrder`}
        element={
          findUserPremission(
            ["Voucher.Purchase.9.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.POrder],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "Order",
                  path: `/billing/clients/${currentClient?.id}/purchase/order`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/editPurchaseOrder/:id`}
        element={
          findUserPremission(
            ["Voucher.Purchase.10.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Payment],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "PurchaseOrder",
                  path: `/billing/clients/${currentClient?.id}/purchase/order`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/purchase/editPurchaseOrderDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Purchase.9.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.POrder],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Purchase",
                  path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                },
                {
                  item: "PurchaseOrder",
                  path: `/billing/clients/${currentClient?.id}/purchase/order`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* Supplier Inside Details Routes */}
      <Route
        path={`/${currentClient?.id}/purchase/supplierLedger/:ledgerId`}
        element={
          <DashboardTemplate
            element={
              <LedgerDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.CreditorsOnly
                }
                showName="Supplier"
              />
            }
            breadcrumprops={[
              {
                item: "Purchase",
                path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
              },
              {
                item: "Suppliers",
                path: `/billing/clients/${currentClient?.id}/purchase/suppliers`,
              },
              {
                item: "Ledger",
              },
            ]}
          />
        }
      />
      <Route
        path={`/${currentClient?.id}/purchase/supplierGroup/:groupId`}
        element={
          <DashboardTemplate
            element={
              <GroupDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.CreditorsOnly
                }
                showName="Income"
              />
            }
            breadcrumprops={[
              {
                item: "Purchase",
                path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
              },
              {
                item: "Suppliers",
                path: `/billing/clients/${currentClient?.id}/purchase/suppliers`,
              },
              {
                item: "Group",
              },
            ]}
          />
        }
      />
    </>
  );
};

export default PurchaseRoute;
